module.exports = __webpack_public_path__ + "img/casa.928b52ad.png";